import { useState } from "react";


interface ScapeCreateModalViewArgs {
    createHandler: (name: string, description: string, isBot: boolean) => void;
    isLoading: boolean;
}

const ScapeCreateModalView: React.FC<ScapeCreateModalViewArgs> = args => {
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [internalIsLoading, setInternalIsLoading] = useState(false);
    const [isBot, setIsBot] = useState(false);

    const isDisabled = name === "" || description === "" || args.isLoading || internalIsLoading;
    return <div>
        <div>
            <label htmlFor="scapeName">Name</label>
            <input
                id="scapeName"
                type="text"
                value={name}
                onChange={e => {
                    setName(e.target.value)
                }}
            />
        </div>
        <div>
            <label htmlFor="scapeDescription">Description</label>
            <input
                id="scapeDescription"
                type="text"
                value={description}
                onChange={e => {
                    setDescription(e.target.value)
                }}
            />
        </div>
        {/* <div>
            <label htmlFor="scapeIsBot">Play Against Bot</label>
            <input
                id="scapeIsBot"
                type="checkbox"
                checked={isBot}
                onChange={e => {
                    setIsBot(e.target.checked)
                }}
            />
        </div> */}
        <div>
            <button
                onClick={e => {
                    setInternalIsLoading(true);
                    args.createHandler(name, description, isBot);
                }}
                disabled={isDisabled}
            >Create</button>
        </div>
    </div>
}

export default ScapeCreateModalView;